// extracted by mini-css-extract-plugin
export default {"code":"app-react-components-Code-Code-module__code","root":"app-react-components-Code-Code-module__root","copyButton":"app-react-components-Code-Code-module__copy-button"};